module.exports = __webpack_public_path__ + "static/media/resume.5ec1cab6.pdf";